import React, { Component } from "react";
import "../styles/components/DownloadApp.css";
class DownloadApp extends Component {
  render() {
    return (
      <div className="downloadAppWrapper" id="downloadAppWrapper">
        <h3 className="downloadAppH3">Shkarko Aplikacionin</h3>
        <a href="https://prifti.ml" target="_blank" rel="noopener noreferrer">
          <img className="appStore" src="images/app-store-badge.webp" alt=" " />
        </a>
        &nbsp;
        <a href="https://prifti.ml" target="_blank" rel="noopener noreferrer">
          <img
            className="appStore"
            src="images/google-play-badge.svg"
            alt=" "
          />
        </a>
      </div>
    );
  }
}
export default DownloadApp;
